import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * StaffRoute component
 * Redirects to dashboard if user is not staff or admin
 * If adminOnly is true, redirects if user is not admin or super_admin
 */
const StaffRoute = ({ children, adminOnly = false }) => {
  const { isStaff, isAdmin, isSuperAdmin, isFPAAdmin, isLoading } = useAuth();

  // Show loading state while checking authentication
  if (isLoading) {
    return <div>Loading...</div>;
  }

  // FPA_ADMIN gets admin-gated access to the invites page only; other adminOnly
  // routes (global admin console, tenant management) remain restricted to ADMIN/SUPER_ADMIN.
  const hasAccess = adminOnly
    ? (isAdmin() || isSuperAdmin() || isFPAAdmin())
    : isStaff();

  // Redirect to dashboard if not authorized
  if (!hasAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  // Render children if authorized
  return children;
};

export default StaffRoute;
